import React, { FC } from "react";
import { OidcLogoutActions } from "firefly-shared-ts-authentication-oidc";
import { Logout } from "./Logout";


export const LogoutCallbackAction: FC = () => {
  return <Logout action={OidcLogoutActions.LogoutCallback} />;
};
